module.exports = __webpack_public_path__ + "static/img/icon-confirmations-type.b8507f8e.svg";